import { connect } from "react-redux";

import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var TextTypes = require("lib/academic/TextTypes");

var PaginationControls = require("components/utility/PaginationControls");
var BookDisplay = require("components/reading/books/BookDisplay");

var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var Glyphicon = require("components/utility/icons/Glyphicon");

var ReadingActions = require("lib/actions/ReadingActions");
var RosterActions = require("lib/actions/RosterActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("reading/picks/add_library_url_pick.scss");

@connect(
	(state, props) => ({
		books: ReadingSelectors.books({ state, filters: { library: true } }),
		platforms: ReadingSelectors.platforms({ state }),
		assignedTextIDs: RosterSelectors.globalStudentListPrefs({ state }).assigned_text_ids,
	}),
	(dispatch, props) => ({
		populateData: () => {
			return Promise.all([
				dispatch(ReadingActions.fetchLibraryOnline({ cache: true })),
				// dispatch(ReadingActions.fetchLibraryPlatforms({ cache: true })),
			]);
		},

		setAssignedTexts: (textIDs) => {
			return dispatch(RosterActions.updateAllStudentListPrefs({
				currentUserID: CurrentUser.get().id,
				update: { assigned_text_ids: textIDs },
			}))

		}
	})
)
@providePopulateData({ waitForLoad: true })
class AddLibraryURLPick extends React.Component {

	constructor(props) {
		super();
		autobind(this);

		this.state = {
			page: 1,
			filters: {}
		};
	}

	applyFilter(key, val) {
		this.setState({
			filters: {
				...this.state.filters,
				[key]: val
			}
		})
	}

	onPageChange(page) {
		this.setState({ page });
	}

	isAssigned(textID) {
		return _.includes(this.props.assignedTextIDs, textID);
	}

	toggleAssign(textID) {
		// if (this.isAssigned(textID)) {
		// 	var textIDs = _.without(this.props.assignedTextIDs, textID);
		// } else {
		// 	var textIDs = this.props.assignedTextIDs.concat(textID);
		// }
		// this.props.setAssignedTexts(textIDs);
		var selectedURLText = _.find(this.props.books, function(item) {
    		return item.text_id == textID 
		});
		this.props.toggleAssign(selectedURLText)
	}

	filteredBooks() {
		var books = this.props.books;

		var { platformID, age, topic, textVariety } = this.state.filters;

		if (platformID) {
			books = _.where(books, { platform_id: platformID });
		}

		if (textVariety) {
			books = _.where(books, { text_variety: textVariety });
		}

		if (age) {
			books = books.filter(x => _.includes(x.ages, age))
		}

		if (topic) {
			books = books.filter(x => _.includes(x.topics, topic))
		}

		return _.sortBy(books, "title");
	}

	pageBooks() {
		var books = this.filteredBooks();
		if (books.length) {
			return _.chunk(books, PER_PAGE)[this.state.page - 1];						
		} else {
			return [];
		}
	}

	renderPlatformSelector() {
		var platformOptions = _.map(this.props.platforms, (platform) => {
			return (
				<ButtonDropdownOption key={ platform.id }
					onClick={ () => this.applyFilter("platformID", platform.id) }>
					{ platform.name }
				</ButtonDropdownOption>
			);
		})

		var selectedPlatform = _.findWhere(this.props.platforms, {
			id: this.state.filters.platformID
		})

		var displayText = selectedPlatform ? selectedPlatform.name : "All Websites";

		return (
			<ButtonDropdown text={ displayText } dropdownDisplay="link">
				<ButtonDropdownOption onClick={ () => this.applyFilter("platformID", null) }>
					All Websites
				</ButtonDropdownOption>
				{ platformOptions }
			</ButtonDropdown>
		);
	}

	renderTextVarietySelector() {
		var displayText = TextTypes.Varieties.getName(
			this.state.filters.textVariety || TextTypes.Varieties.FICTION_AND_NON_FICTION
		);

		return (
			<ButtonDropdown text={ displayText } dropdownDisplay="link">
				<ButtonDropdownOption onClick={ () => this.applyFilter("textVariety", null) }>
					{ TextTypes.Varieties.getName(TextTypes.Varieties.FICTION_AND_NON_FICTION) }
				</ButtonDropdownOption>
				<ButtonDropdownOption onClick={ () => this.applyFilter("textVariety", TextTypes.Varieties.FICTION) }>
					{ TextTypes.Varieties.getName(TextTypes.Varieties.FICTION) }
				</ButtonDropdownOption>
				<ButtonDropdownOption onClick={ () => this.applyFilter("textVariety", TextTypes.Varieties.NON_FICTION) }>
					{ TextTypes.Varieties.getName(TextTypes.Varieties.NON_FICTION) }
				</ButtonDropdownOption>
			</ButtonDropdown>
		);
	}

	renderAgeSelector() {
		var ages = _.sortBy(_.uniq(_.flatten(this.props.books.map(p => p.ages))), (age) => {
			if (age == "K-1") {
				return 0;
			} else {
				return parseInt(age.split("-"));
			}
		});

		var platformOptions = _.map(ages, (age) => {
			return (
				<ButtonDropdownOption key={ age }
					onClick={ () => this.applyFilter("age", age) }>
					{ age }
				</ButtonDropdownOption>
			);
		})


		var displayText = this.state.filters.age || "All Grades";

		return (
			<ButtonDropdown text={ displayText } dropdownDisplay="link">
				<ButtonDropdownOption onClick={ () => this.applyFilter("age", null) }>
					All Grades
				</ButtonDropdownOption>
				{ platformOptions }
			</ButtonDropdown>
		);

	}

	renderTopicSelector() {
		var topics = _.uniq(_.flatten(this.props.books.map(p => p.topics))).sort();

		var platformOptions = _.map(topics, (topic) => {
			return (
				<ButtonDropdownOption key={ topic }
					onClick={ () => this.applyFilter("topic", topic) }>
					{ topic }
				</ButtonDropdownOption>
			);
		})


		var displayText = this.state.filters.topic || "Any Topic";

		return (
			<ButtonDropdown text={ displayText } dropdownDisplay="link">
				<ButtonDropdownOption onClick={ () => this.applyFilter("topic", null) }>
					Any Topic
				</ButtonDropdownOption>
				{ platformOptions }
			</ButtonDropdown>
		);
	}

	renderTexts() {
		var filteredBooks = this.pageBooks().length; // instead of using this.props.books.length...
		if (filteredBooks > 0) {
			return this.pageBooks().map((book) => {

				if (this.isAssigned(book.text_id)) {
					var assignAction = (
						<div>
							<Glyphicon icon="ok" /> Assigned
						</div>
					);
				} else {
					var assignAction = (
						<button className="btn btn-default" onClick={ () => this.toggleAssign(book.text_id) }>
							Assign
						</button>
					);
				}

				return (
					<div className="assignable" key={ book.text_id }>
						<BookDisplay textID={ book.text_id } showCover showURL showLibraryTags />
						<div className="actions">
							{ assignAction }
						</div>
					</div>
				)
			})
		} else {
			return (
				<div className="noResultsText">We don't have these texts yet. Try searching for another text.</div>
			)
		}
	}

	renderPagination() {
		var bookCount = this.filteredBooks().length;

		if ((bookCount / PER_PAGE) > 1) {
			return (
				<PaginationControls page={ this.state.page }
					perPage={ PER_PAGE }
					totalCount={ bookCount }
					onPageChange={ this.onPageChange } />
			);
		}
	}
	render() {
		var textVariety = this.state.filters.textVariety;
		if (textVariety != TextTypes.Varieties.FICTION) {
			var topicSelector = this.renderTopicSelector()
		}
		return (
			<div className="addLibraryURLPick">
				<div className="filters">
					{ this.renderAgeSelector() }
					{ this.renderPlatformSelector() }
					{ this.renderTextVarietySelector() }
					{ topicSelector }
				</div>
				{ this.renderTexts() }
				{ this.renderPagination() }
			</div>
		)
	}
};

var PER_PAGE = 25;

AddLibraryURLPick.WrappedComponent.propTypes = StrictPropTypes({
	toggleAssign: PropTypes.func,
	// Data from @connect
	books: PropTypes.array,
	platforms: PropTypes.array,
	assignedTextIDs: PropTypes.array,

	// Handlers from @connect
	populateData: PropTypes.func.isRequired,
	setAssignedTexts: PropTypes.func,
});

module.exports = AddLibraryURLPick;



// WEBPACK FOOTER //
// ./modules/components/reading/picks/AddLibraryURLPick.js